export const TEST_DRIVE = {
  badge: "TEST-DRIVE IN REAL TIME",
  headlineLead: "Test Your New",
  headlineGain: "Roofing Digital Employee",
  headlineTail: "Right Now",
  body:
    "Enter your mobile number below. Our Digital Employee will message you in under 26 seconds, qualify your project, and attempt to lock an estimate slot into the calendar. Time it with your stopwatch.",
  serviceLabel: "Service",
  addressLabel: "Full Address",
  namePlaceholder: "Your Full Name",
  emailPlaceholder: "you@email.com",
  phonePlaceholder: "Your Direct Mobile Phone Number",
  cta: "Test Response Speed in 26 Seconds ⚡",
  ctaSending: "Sending…",
  timerPrefix: "Live execution timer:",
  disclosure: "100% Free • Interactive Simulation • No Spam",
  nudge:
    "Liked the response speed? Put this exact 26-second algorithm on your own website in 12 minutes.",
  nudgeCta: "Hire Your Roofing Digital Employee — 14 Days Free",
  errorFillAll: "Please fill in all fields.",
  errorUnsupportedRegion: "Test drive isn’t available in your region yet.",
  errorTryAgain: "Couldn’t start test drive. Try again.",
  logs: [
    { time: "[00:01.20]", event: "Inbound lead event captured..." },
    { time: "[00:03.45]", event: "Triggering Digital Assistant..." },
    { time: "[00:05.10]", event: "Outbound message initiated to [Phone Number]..." },
  ],
  finalStatus: "CONNECTED — QUALIFYING LEAD",
};
